"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormTextField = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _constants = require("../../constants");
var _jsxRuntime = require("react/jsx-runtime");
const FormTextField = ({
  id,
  label
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    errors
  } = (0, _reactHookForm.useFormState)();
  const {
    register
  } = (0, _reactHookForm.useFormContext)();
  const helperText = errors[id]?.message?.toString();
  const hasError = !!errors[id];
  const textFieldInputProps = (0, _react.useMemo)(() => ({
    [_constants.DATA_TEST_ID]: getTestId(id),
    maxLength: _constants.FORM_TEXT_FIELD_LIMIT
  }), [getTestId, id]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Stack, {
    spacing: 3,
    "data-testid": getTestId('form-text-field'),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.TextField, {
      ...register(id),
      fullWidth: true,
      id: id,
      error: hasError,
      helperText: helperText,
      inputProps: textFieldInputProps,
      variant: "outlined",
      placeholder: label
    })
  });
};
exports.FormTextField = FormTextField;
